<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.feedback')"
    resource="feedbacks"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/feedbacks.js';

@Component
export default class Feedbacks extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'phone_cont',
      {
        key: 'is_resolve_eq',
        renderCell: {
          component: 'select',
          props: {
            options: [
              { label: this.$t('bean.yes'), value: true },
              { label: this.$t('bean.no'), value: false },
            ]
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      {
        prop: 'creator',
        label: `${this.$t('model.user')} ${this.$t('user.phone')}`,
        renderCell: (h, { props: { value } }) => {
          if (value) {
            if (value.cn === 'User') {
              return <bean-link KeepNode to={{ name: 'users.show', params: { id: value.id } }}>{value.verification_state === 'approved' ? value.name : value.phone}</bean-link>
            } else {
              return <bean-link KeepNode to={{ name: 'agents.show', params: { id: value.id } }}>{value.name || value.phone}</bean-link>
            }
          }
        }
      },
      'phone',
      'description',
      'is_resolve',
      type === 'show' && 'solver',
      type === 'show' && 'images',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'phone',
      'description',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'feedbacks.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('resolve'),
          type: 'success',
          can: 'feedbacks.resolve'
        },
        on: {
          confirm: async () => {
            await this.$request.put(`/feedbacks/${row.id}/resolve`);
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'feedbacks.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/feedbacks',
    name: 'feedbacks.index',
    component: Feedbacks,
    props: {
      type: 'index',
    }
  },
  {
    path: '/feedbacks/new',
    name: 'feedbacks.new',
    component: Feedbacks,
    props: {
      type: 'new',
    }
  },
  {
    path: '/feedbacks/:id',
    name: 'feedbacks.show',
    component: Feedbacks,
    props: {
      type: 'show',
    }
  },
  {
    path: '/feedbacks/:id/edit',
    name: 'feedbacks.edit',
    component: Feedbacks,
    props: {
      type: 'edit'
    }
  }
]
</script>
